<div class="p-6">
  @if (loading) {
    <div class="flex justify-center py-8">
      <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-brand-500"></div>
    </div>
  }

  @if (error) {
    <div class="mb-4 p-3 rounded-lg bg-error-50 border border-error-200 text-sm text-error-700 dark:bg-error-500/10 dark:border-error-500/20 dark:text-error-400">
      {{ error }}
    </div>
  }

  @if (!loading) {
    <form [formGroup]="form" (ngSubmit)="guardar()" class="space-y-4">

      <!-- Usuario -->
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Usuario <span class="text-error-500">*</span>
        </label>
        @if (loadingUsers) {
          <div class="flex items-center gap-2 px-3 py-2.5 rounded-lg border border-dashed border-gray-300 dark:border-gray-600">
            <div class="animate-spin rounded-full h-3.5 w-3.5 border-b-2 border-brand-500"></div>
            <span class="text-xs text-gray-500 dark:text-gray-400">Cargando usuarios...</span>
          </div>
        } @else {
          <select
            formControlName="userId"
            class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
            [class.border-error-500]="hasError('userId')"
            [class.border-gray-300]="!hasError('userId')"
          >
            <option [ngValue]="null">Selecciona un usuario...</option>
            @for (user of users; track user.id) {
              <option [ngValue]="user.id">{{ userLabel(user) }}</option>
            }
          </select>
        }
        @if (hasError('userId')) {
          <p class="mt-1.5 text-sm text-error-500">{{ getError('userId') }}</p>
        }
      </div>

      <!-- Cargo -->
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Cargo <span class="text-error-500">*</span>
        </label>
        <input
          type="text"
          formControlName="cargo"
          placeholder="Ej: Ejecutiva Comercial"
          class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
          [class.border-error-500]="hasError('cargo')"
          [class.border-gray-300]="!hasError('cargo')"
        />
        @if (hasError('cargo')) {
          <p class="mt-1.5 text-sm text-error-500">{{ getError('cargo') }}</p>
        }
      </div>

      <!-- Email -->
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Correo <span class="text-gray-400 font-normal">(opcional, se autocompleta del usuario)</span>
        </label>
        <input
          type="email"
          formControlName="email"
          placeholder="Ej: ventas@empresa.com"
          class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
          [class.border-error-500]="hasError('email')"
          [class.border-gray-300]="!hasError('email')"
        />
        @if (hasError('email')) {
          <p class="mt-1.5 text-sm text-error-500">{{ getError('email') }}</p>
        }
      </div>

      <!-- Monto máximo -->
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Monto máximo de aprobación <span class="text-gray-400 font-normal">(opcional, vacío = sin límite)</span>
        </label>
        <input
          type="number"
          min="0"
          step="0.01"
          formControlName="approvalLimit"
          placeholder="Sin límite"
          class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
          [class.border-error-500]="hasError('approvalLimit')"
          [class.border-gray-300]="!hasError('approvalLimit')"
        />
        @if (hasError('approvalLimit')) {
          <p class="mt-1.5 text-sm text-error-500">{{ getError('approvalLimit') }}</p>
        }
      </div>

      <!-- Activo -->
      <div class="flex items-center gap-3">
        <input
          id="isActiveApprover"
          type="checkbox"
          formControlName="isActive"
          class="h-4 w-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500"
        />
        <label for="isActiveApprover" class="text-sm text-gray-700 dark:text-gray-300">Activo</label>
      </div>

      <!-- ============ Firma registrada ============ -->
      <div class="pt-2 border-t border-gray-200 dark:border-gray-700">
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Firma registrada <span class="text-error-500">*</span>
        </label>

        <!-- Estado en edición: firma existente + opción de reemplazar -->
        @if (isEditing && !capturingSignature) {
          <div class="rounded-lg border border-gray-200 dark:border-gray-700 p-3">
            @if (hasSignature && currentSignatureData) {
              <div class="flex items-center gap-3">
                @if (isCurrentSignatureImage) {
                  <img [src]="currentSignatureData" alt="Firma registrada" class="h-12 object-contain bg-white rounded">
                } @else {
                  <span class="text-2xl italic text-brand-600"
                    style="font-family: 'Brush Script MT', 'Segoe Script', 'Lucida Handwriting', cursive;">
                    {{ currentSignatureData }}
                  </span>
                }
                <span class="inline-flex items-center gap-1 text-xs font-medium text-success-600 dark:text-success-400">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                  </svg>
                  Firma registrada
                </span>
              </div>
            } @else {
              <p class="text-sm text-warning-600 dark:text-warning-400">Sin firma registrada.</p>
            }
            <button type="button" (click)="iniciarCapturaFirma()"
              class="mt-3 text-xs font-medium text-brand-600 dark:text-brand-400 hover:underline">
              {{ hasSignature ? 'Reemplazar firma' : 'Registrar firma' }}
            </button>
          </div>
        }

        <!-- Captura de firma -->
        @if (capturingSignature) {
          <div class="rounded-lg border border-gray-200 dark:border-gray-700 p-3 space-y-3">
            <!-- Tabs -->
            <div class="grid grid-cols-3 gap-1 p-1 rounded-lg bg-gray-100 dark:bg-gray-800">
              <button type="button" (click)="setSignTab('drawn')"
                class="px-2 py-1.5 rounded-md text-sm font-medium transition-colors"
                [class]="signTab === 'drawn' ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-white shadow-sm' : 'text-gray-500 dark:text-gray-400'">
                Dibujar
              </button>
              <button type="button" (click)="setSignTab('typed')"
                class="px-2 py-1.5 rounded-md text-sm font-medium transition-colors"
                [class]="signTab === 'typed' ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-white shadow-sm' : 'text-gray-500 dark:text-gray-400'">
                Escribir
              </button>
              <button type="button" (click)="setSignTab('uploaded')"
                class="px-2 py-1.5 rounded-md text-sm font-medium transition-colors"
                [class]="signTab === 'uploaded' ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-white shadow-sm' : 'text-gray-500 dark:text-gray-400'">
                Subir
              </button>
            </div>

            <!-- Dibujar -->
            @if (signTab === 'drawn') {
              <div>
                <div class="rounded-lg border-2 border-dashed border-gray-300 dark:border-gray-600 bg-white overflow-hidden">
                  <canvas #signCanvas class="block w-full h-40 touch-none cursor-crosshair"
                    (pointerdown)="onPointerDown($event)"
                    (pointermove)="onPointerMove($event)"
                    (pointerup)="onPointerUp($event)"
                    (pointercancel)="onPointerUp($event)"></canvas>
                </div>
                <div class="flex items-center justify-between mt-1.5">
                  <p class="text-xs text-gray-400 dark:text-gray-500">Dibuja la firma dentro del recuadro.</p>
                  <button type="button" (click)="limpiarFirma()" [disabled]="!hasDrawing"
                    class="text-xs font-medium text-gray-500 dark:text-gray-400 hover:text-error-600 disabled:opacity-40">
                    Limpiar
                  </button>
                </div>
              </div>
            }

            <!-- Escribir -->
            @if (signTab === 'typed') {
              <div>
                <div class="rounded-lg border-2 border-dashed border-gray-300 dark:border-gray-600 h-32 flex items-center justify-center px-4 bg-white dark:bg-gray-800 mb-2">
                  <span class="text-3xl text-gray-800 dark:text-white italic text-center break-words max-w-full"
                    style="font-family: 'Brush Script MT', 'Segoe Script', 'Lucida Handwriting', cursive;">
                    {{ typedPreview }}
                  </span>
                </div>
                <input type="text" [(ngModel)]="typedSignature" [ngModelOptions]="{ standalone: true }"
                  placeholder="Nombre para la firma tipográfica"
                  class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90">
              </div>
            }

            <!-- Subir -->
            @if (signTab === 'uploaded') {
              <div>
                @if (uploadedSignature) {
                  <div class="rounded-lg border-2 border-dashed border-gray-300 dark:border-gray-600 h-40 flex items-center justify-center bg-white p-3">
                    <img [src]="uploadedSignature" alt="Firma subida" class="max-h-full max-w-full object-contain">
                  </div>
                  <div class="flex justify-end mt-1.5">
                    <button type="button" (click)="quitarImagenFirma()"
                      class="text-xs font-medium text-gray-500 dark:text-gray-400 hover:text-error-600">
                      Quitar imagen
                    </button>
                  </div>
                } @else {
                  <label class="rounded-lg border-2 border-dashed border-gray-300 dark:border-gray-600 h-40 flex flex-col items-center justify-center gap-2 cursor-pointer hover:border-gray-400 dark:hover:border-gray-500 bg-white dark:bg-gray-800">
                    <svg class="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                        d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                    </svg>
                    <span class="text-sm text-gray-600 dark:text-gray-300 font-medium">Selecciona una imagen de la firma</span>
                    <span class="text-xs text-gray-400">PNG o JPG, máximo 1 MB</span>
                    <input type="file" accept="image/png,image/jpeg" class="hidden" (change)="onSignatureFileSelected($event)">
                  </label>
                }
                @if (uploadError) {
                  <p class="text-xs text-error-600 dark:text-error-400 mt-1.5">{{ uploadError }}</p>
                }
              </div>
            }

            @if (isEditing) {
              <button type="button" (click)="cancelarCapturaFirma()"
                class="text-xs font-medium text-gray-500 dark:text-gray-400 hover:underline">
                Cancelar reemplazo de firma
              </button>
            }
          </div>
        }
      </div>

      <!-- Footer -->
      <div class="flex items-center justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
        <button type="button" (click)="cancelar()"
          class="px-4 py-2.5 rounded-lg text-sm font-medium text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 transition-colors">
          Cancelar
        </button>
        <button type="submit" [disabled]="saving || form.invalid"
          class="px-5 py-2.5 rounded-lg text-sm font-semibold text-white bg-brand-600 hover:bg-brand-700 transition-colors disabled:opacity-50 flex items-center gap-2">
          @if (saving) {
            <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
          }
          {{ saving ? 'Guardando...' : (isEditing ? 'Actualizar' : 'Crear') }}
        </button>
      </div>
    </form>
  }
</div>
